import React from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { AppState, Dispatcher, RootState } from 'AppTypes'

import { switchLanguage } from '@app/state_management/slices'

type Props = {
  appState: AppState
  dispatch: Dispatcher
}

const AccountInfo: React.FC<Props> = ({
  appState: {
    language,
    currentStore
  },
  dispatch
}) => {
  const { t } = useTranslation()
  const dispatchSwitchLanguage = () => dispatch(switchLanguage(language === 'jp' ? 'en' : 'jp'))

  if (!currentStore.storeName) return null

  return (
    <>
      <ul className="navbar-nav">
        <li className="nav-item d-none d-sm-inline-block">
          <span style={{ fontSize: '20px' }}>
            { t('mainToolbar.welcomeTxt') }
          </span>
          <br />
          <span style={{ fontSize: '23px' }}>
            {`${currentStore.storeName || ''} ${currentStore.branchName || ''}`}
          </span>
        </li>
        <li className="nav-item d-none d-sm-inline-block">
          <button onClick={dispatchSwitchLanguage} type="button" className="btn btn-block btn-white btn-lg">
            { t('mainToolbar.switchStoreBtn') }
          </button>
        </li>
      </ul>
    </>
  )
}

export default connect((state: RootState) => ({
  appState: state.app
}))(AccountInfo)
